module.exports={account_link_complete_message:"Nexon Account Link is complete."};